import i18n from "@/i18n";

/**
 * Returns the current UI language as a short code ("fr", "en", "it").
 * Used for JSON-LD `inLanguage` fields so schemas match the rendered content.
 */
export function getCurrentLang(): "fr" | "en" | "it" {
  const l = (i18n.language || "fr").toLowerCase();
  if (l.startsWith("it")) return "it";
  if (l.startsWith("en")) return "en";
  return "fr";
}

/**
 * Translated breadcrumb labels reused across JSON-LD schemas so structured
 * data matches the visible language.
 */
export function getBreadcrumbLabels() {
  const t = i18n.t.bind(i18n);
  return {
    home: t("breadcrumb.home", "Accueil"),
    news: t("breadcrumb.news", "Actualités"),
    privateEvents: t("breadcrumb.privateEvents", "Événements privés"),
    faq: t("faq.title", "FAQ"),
    menu: t("menus.title", "Nos Cartes"),
  };
}
